import { submitPortalMessage, type PortalSubmission } from '@/api/portal'

const mobilePattern = /^1[3-9]\d{9}$/
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const businessFormTypes = new Set(['FREE_TRIAL', 'PARTNER_APPLICATION', 'EVENT_REGISTRATION', 'ICP_FILING'])
const placeholderTexts = new Set(['test', 'testing', 'aaaa', 'abcd', 'qwer', 'asdf', 'none', 'null', '未知'])

function isMeaningfulText(value: string, minLength: number, maxLength: number) {
  const normalized = value.trim().replace(/\s+/g, '')
  if (normalized.length < minLength || normalized.length > maxLength) return false
  if (/^\d+$/.test(normalized) || /(.)\1{2,}/.test(normalized)) return false
  return !placeholderTexts.has(normalized.toLowerCase())
}

function isValidMobile(value: string) {
  if (!mobilePattern.test(value) || /(\d)\1{5,}/.test(value)) return false
  for (let start = 0; start <= value.length - 6; start += 1) {
    const part = value.slice(start, start + 6)
    const differences = Array.from({ length: 5 }, (_, index) => Number(part[index + 1]) - Number(part[index]))
    if (differences.every((difference) => difference === 1 || difference === -1)) return false
  }
  return true
}

export async function submitPortalForm(data: PortalSubmission) {
  const payload: PortalSubmission = {
    ...data,
    username: data.username.trim(),
    companyName: data.companyName?.trim(),
    tel: data.tel.trim(),
    email: data.email?.trim(),
    address: data.address?.trim(),
    content: data.content?.trim(),
    productName: data.productName?.trim(),
    type: data.type.trim()
  }

  if (!isMeaningfulText(payload.username, 2, 30)) throw new Error('请填写真实联系人姓名')
  if (businessFormTypes.has(payload.type) && !isMeaningfulText(payload.companyName || '', 4, 100)) {
    throw new Error('请填写真实的企业或主办单位名称')
  }
  if (payload.companyName && !isMeaningfulText(payload.companyName, 4, 100)) {
    throw new Error('请填写真实的企业或主办单位名称')
  }
  if (!isValidMobile(payload.tel)) throw new Error('请输入真实有效的中国大陆手机号')
  if (payload.email && !emailPattern.test(payload.email)) throw new Error('请输入正确的邮箱地址')
  if (!payload.type) throw new Error('提交类型不能为空')
  if ((payload.content?.length || 0) > 2000) throw new Error('内容不能超过 2000 个字符')

  return submitPortalMessage(payload)
}

export function getSubmitErrorMessage(error: unknown) {
  return error instanceof Error && error.message ? error.message : '提交失败，请稍后重试'
}
